import { ServiceDoctorSelectInputStore } from './service-doctor-select-input.store';
import { fb } from '../../../../modules/shared/shared.global-service';
import { Component, computed, effect, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { SelectInputComponent } from '../../../kit/input/select-input/select-input.component';
import { InfiniteScrollStore } from '../../../../modules/shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { getDoctorsFrag } from './service-doctor-select-input.query';
import { FormGroup } from '@angular/forms';
import { EmploymentEnum } from '@libs/types/src/user/enum/employment.enum';
import { DoctorChipComponent } from '../../../kit/doctor-chip/doctor-chip.component';

@Component({
    selector: 'app-service-doctor-select-input',
    templateUrl: './service-doctor-select-input.component.html',
    styleUrl: './service-doctor-select-input.component.scss',
    providers: [ServiceDoctorSelectInputStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectInputComponent,
        DoctorChipComponent,
    ],
})
export class ServiceDoctorSelectInputComponent {

    public readonly store = inject(ServiceDoctorSelectInputStore);

    public form = input<FormGroup>(fb.group({
        doctorId: fb.control<string | null>(null),
    }));
    public serviceId = input(this.store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0);
    public disabled = input(false);

    public forceRefresh = signal({});

    public currentUser = computed(() => this.store.globalGlobalStore.loggedUserStore.currentUser());

    public doctorScroll = computed(() => {
        this.forceRefresh();

        const filter = new FilterBuilder();
        filter.limit(100)
            .where('doctor', true)
            .organizationId(this.store.globalGlobalStore.organizationStore.selectedId())
            .serviceId(this.serviceId())
            .orWhere('noServiceId', true, 'EMPTY')
        ;

        return new InfiniteScrollStore(
            this.store.api.getUsers,
            filter.filter(),
            true,
            getDoctorsFrag,
        );
    });

    constructor() {
        effect(() => {
            if (
                this.currentUser() &&
                this.form().get('doctorId')?.value === null &&
                this.currentUser()?.employments?.some(e => e.employmentTypeName === EmploymentEnum.DOCTOR)
            ) {
                this.form().patchValue({
                    doctorId: this.currentUser()!.id,
                });
            }
        });
    }
}
